import { initMap, equalCols, getCookie } from '../functions';
import Swal from 'sweetalert2'

$(document).ready(function() {

	const corporateOfferRequestLead = {
        isLoading: false,
        init() {
            $(document).on('click', '.corporate-offer-request-show-form', this, this.show);
            $(document).on('click', '#corporate-offer-request-send-btn', this, this.send);

			$(document).on('click', '.buy_back_radio .form-check', function(){
				$('.buy_back_radio .form-check').removeClass("selected");
				$('.buy_back_radio .form-check-input').prop('checked', false);
				$(this).addClass("selected");
				$(this).find(".form-check-input").prop('checked', true);
			});
			$(document).on('click', '.trade_in_radio .form-check', function(){
				$('.trade_in_radio .form-check').removeClass("selected");
				$('.trade_in_radio .form-check-input').prop('checked', false);
				$(this).addClass("selected");
				$(this).find(".form-check-input").prop('checked', true);
			});
			$(document).on('click', '.financial_leasing_radio .form-check', function(){
				$('.financial_leasing_radio .form-check').removeClass("selected");
				$('.financial_leasing_radio .form-check-input').prop('checked', false);
				$(this).addClass("selected");
				$(this).find(".form-check-input").prop('checked', true);
			});
			$(document).on('click', '.operational_leasing_radio .form-check', function(){
				$('.operational_leasing_radio .form-check').removeClass("selected");
				$('.operational_leasing_radio .form-check-input').prop('checked', false);
				$(this).addClass("selected");
				$(this).find(".form-check-input").prop('checked', true);
			});
			$(document).on('click', '.financing-radio .form-check', function(){
				$('.financing-radio .form-check').removeClass("selected");
				$('.financing-radio .form-check-input').prop('checked', false);
				$(this).addClass("selected");
				$(this).find(".form-check-input").prop('checked', true);
			});
			$(document).on('click', '.offer-request-newsletter-radio .form-check', function(){
				$('.offer-request-newsletter-radio .form-check').removeClass("selected");
				$('.offer-request-newsletter-radio .form-check-input').prop('checked', false);
				$(this).addClass("selected");
				$(this).find(".form-check-input").prop('checked', true);
			});

			$(document).on('click', '.models_of_interest_btn', function(){
				$('#models_of_interest_list').fadeToggle();
			});
			$(document).on('click', '.models_of_interest_item_btn', function(){
				var modelsIds = $('#models_of_interest').val().split(',').filter(function(value) {
					return value.trim() !== "";
				}).map(function(value) {
					return value;
					//return 1*value;
				});

				var index = modelsIds.indexOf($(this).data('id'));
				if (index == -1) {
					modelsIds.push($(this).data('id'));
					$(this).parent().addClass('active');
				} else {
					modelsIds.splice(index, 1);
					$(this).parent().removeClass('active');
				}

				$('#models_of_interest').val(modelsIds.join(','));
			});
        },
		send(event) {
			const _this = event.data;
			event.preventDefault();

			let dealerId = 1*$(this).data('dealer-id');
			let modelId = 1*$(this).data('model-id');

			if (_this.isLoading) {
                return false;
            }

			let errors = false;
			$('#corporate-offer-request').find('.form-control').removeClass('is-invalid');
			$('#corporate-offer-request').find('.form-check-input').removeClass('is-invalid');
			$('#or-notifications').html('');

			if ($('#company_name').val() == '') {
				$('#company_name').addClass('is-invalid');
				errors = true;
			}
			if ($('#company_cui').val() == '') {
				$('#company_cui').addClass('is-invalid');
				errors = true;
			}
			if ($('#name').val() == '') {
				$('#name').addClass('is-invalid');
				errors = true;
			}
			if ($('#email').val() == '') {
				$('#email').addClass('is-invalid');
				errors = true;
			}
			if ($('#phone').val() == '') {
				$('#phone').addClass('is-invalid');
				errors = true;
			}
			if ($('#vehicles_number option:selected').val() == '') {
				$('#vehicles_number').addClass('is-invalid');
				errors = true;
			}
			if ($('#intend_to_buy_in option:selected').val() == '') {
				$('#intend_to_buy_in').addClass('is-invalid');
				errors = true;
			}
			if ($('#models_of_interest').val() == '') {
				$('#models_of_interest').addClass('is-invalid');
				$('.models_of_interest_btn').addClass('is-invalid');
				errors = true;
			}
			if (!$('input[name="buy_back"]').is(':checked')) {
				errors = true;
			}
			if (!$('input[name="trade_in"]').is(':checked')) {
				errors = true;
			}
			if (!$('input[name="financial_leasing"]').is(':checked')) {
				errors = true;
			}
			if (!$('input[name="operational_leasing"]').is(':checked')) {
				errors = true;
			}
			// if (!$('input[name="financing"]').is(':checked')) {
			// 	errors = true;
			// }
			if (!$('#offer-request-terms-and-condition').is(":checked")) {
				$('#offer-request-terms-and-condition').addClass('is-invalid');
				errors = true;
			}

			if (errors) {
				$('#or-notifications').html('<div class="alert alert-danger" role="alert">Va rugam completati toate campurile!</div>');
				document.getElementById('corporate-offer-request').scrollTop = 0;
				return false;
			}

			//Loading...
            _this.isLoading = true;
			let element = this;
			$(element).find('i').show();

			var values = '&company=' + $('#company_name').val();
			values += '&cui=' + $('#company_cui').val();
			values += '&name=' + $('#name').val();
			values += '&email=' + $('#email').val();
			values += '&phone=' + $('#phone').val();
			values += '&vehicles_number=' + $('#vehicles_number option:selected').val();
			values += '&intend_to_buy_in=' + $('#intend_to_buy_in option:selected').val();
			values += '&models_of_interest=' + $('#models_of_interest').val();
			values += '&buy_back=' + ($('input[name="buy_back"]').is(':checked')?1:0);
			values += '&trade_in=' + ($('input[name="trade_in"]').is(':checked')?1:0);
			values += '&financial_leasing=' + ($('input[name="financial_leasing"]').is(':checked')?1:0);
			values += '&operational_leasing=' + ($('input[name="operational_leasing"]').is(':checked')?1:0);
			//values += '&financing=' + $('input[name="financing"]:checked').val();
			values += '&message=' + $('#message').val();
			values += '&newsletter=' + ($('.offer-request-newsletter:checked').val()?$('.offer-request-newsletter:checked').val():0);
			values += '&_token=' + $('#_token_or').val();
			$.ajax({
	            type: "POST",
	            url: corporateOfferRequestRoutePost,
	            data: values,
	            success: function(response) {
					_this.isLoading = false;
					$(element).find('i').hide();

					if (response.status == 0) {
                        var errorHtml = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $('#' + errorKey).addClass('is-invalid');
                                //errorHtml += response.errors[errorKey][error] + '<br>';
                            }
                        }
						$('#or-notifications').html('<div class="alert alert-danger" role="alert">Va rugam completati toate campurile!</div>');
                        return false;
                    }

					if (response.status == 1) {
						$('#corporate-offer-request').modal('hide');
						$('#corporate-offer-request').on('hidden.bs.modal', function() {
							$('#corporate-offer-request-container').html('');
						});

						Swal.fire({
							icon: 'success',
							title: 'Success!',
							html: formSuccessMessage
						});

						if (cookies_advertisement == 1) {
							gtag('event', 'conversion', {'send_to': 'AW-732195211/z_5UCI7a8-cBEIvTkd0C'});
						}

						if (cookies_advertisement == 1 || cookies_social == 1) {
							fbq('track', 'Lead');
						}

						return false;
					}

					$('#or-notifications').html('<div class="alert alert-danger" role="alert">'+response.message+'</div>');
	            },
                error(error) {
                    _this.isLoading = false;
					$(element).find('i').hide();
                },
	        });
		},
		show(event) {
			const _this = event.data;
			event.preventDefault();

			if (_this.isLoading) {
                return false;
            }

			//Loading...
            _this.isLoading = true;
			let element = this;
			if ($(element).data('model') != '') {

			} else {
				$(element).find('i').removeClass('fa-file-alt').addClass('fa-spinner fa-spin');
			}

			var values = 'model_name=' + ($(this).data('model') != '' ?  $(this).data('model') : '');
			$.ajax({
	            type: "GET",
	            url: corporateOfferRequestRoute,
	            data: values,
	            success: function(response) {
					//check if full menu is open, if is close it
					// if ($('.meniu-desktop').hasClass('open')) {
					// 	$('.meniu-desktop').removeClass('open');
					// }
					$(".header").removeClass('mobile-meniu-open');

					$('#corporate-offer-request-container').html(response);
					$('#corporate-offer-request').modal('show');

					$('#corporate-offer-request').on('shown.bs.modal', function (e) {
						if ($(document).width() > 1025) {
							equalCols('.corporate-offer-request-eq-height');
						}

						// Reference to the element you want to detect clicks outside of
						var elementToDetectClickOutside = document.getElementById('models_of_interest_list');
						// Add a click event listener to the document
						document.addEventListener('click', function(event) {
							var clickedElement = event.target;
							if($(clickedElement).hasClass('models_of_interest_btn')) {
								return;
							}

							// Check if the clicked element is the element you want to detect clicks outside of or is a child of that element
							if (clickedElement !== elementToDetectClickOutside && !elementToDetectClickOutside.contains(clickedElement)) {
								// The click occurred outside of the element, you can perform your action here
								$('#models_of_interest_list').fadeOut();
							}
						});
					});

					_this.isLoading = false;
					if ($(element).data('model') != '') {

					} else {
						$(element).find('i').removeClass('fa-spinner fa-spin').addClass('fa-file-alt');
					}
	            },
                error(error) {
                    _this.isLoading = false;
					if ($(element).data('model') != '') {

					} else {
						$(element).find('i').removeClass('fa-spinner fa-spin').addClass('fa-file-alt');
					}
                },
	        });
		}
    };

    if ($('.corporate-offer-request-show-form').length) {
        corporateOfferRequestLead.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/corporate-offer-request-lead.js